import { Route, useNavigate } from "react-router-dom";

import AccountabilityRoutes from "@/accountability/AccountabilityRoutesLazy";
import MacrogeneratorRoutes from "@/macrogenerators/router/MacrogeneratorRoutesLazy";
import PresenteeismRoutes from "@/presenteeism/router/PresenteeismRoutesLazy";
import { cn } from "@/styles/cn";
import { isInIframe } from "@/features/auth/helpers/isInIframe";
import { CenterLayout, ResultBlocker } from "@/components";
import { LoadingModule } from "@/components/molecules";
import { RoutesWithNotFound } from "@/components/organisms/RoutesWithNotFound/RoutesWithNotFound";
import { PowerBiPage } from "@/features/powerbi-dashboards/page/PowerBiPage";

import { PathNamekAppsRoutes, PathNamekRoutes } from "./constants";
import { useNamekRouter } from "./Namek.router.hook";
import { Welcome } from "./components/Welcome/Welcome";
import { Navbar } from "./components/Navbar";

const NamekRouter = () => {
  const navigate = useNavigate();
  const { isLoading, hasEmptyPermission } = useNamekRouter();

  const navigateToWelcome = () => {
    navigate(`/`, { replace: true });
  };

  if (hasEmptyPermission) {
    return (
      <CenterLayout>
        <ResultBlocker
          showSupport
          status="unauthorized"
          subTitle="Por favor, ponte en contacto con nuestro equipo de soporte para que podamos resolver este inconveniente"
          title="No tiene permisos asignados"
        />
      </CenterLayout>
    );
  }

  if (isLoading) {
    return <LoadingModule />;
  }

  return (
    <div className="flex h-full flex-col">
      <Navbar />

      <div className={cn("flex h-full flex-col overflow-auto px-6")}>
        <RoutesWithNotFound onBack={() => navigateToWelcome()}>
          <Route index element={<Welcome />} path="/" />

          <Route
            element={<AccountabilityRoutes />}
            path={`/${PathNamekAppsRoutes.ACCOUNTABILITY}/*`}
          />

          <Route
            element={<MacrogeneratorRoutes />}
            path={`/${PathNamekAppsRoutes.MACROGENERATORS}/*`}
          />

          <Route element={<PresenteeismRoutes />} path={`/${PathNamekAppsRoutes.PRESETEEISM}/*`} />

          <Route element={<PowerBiPage />} path={`${PathNamekRoutes.POWERBI.DASHBOARD}/:code`} />
        </RoutesWithNotFound>
      </div>
    </div>
  );
};

export default NamekRouter;
